import React from "react";
import { DotsLoader } from "@activecollab/components";

const PageLoader = () => {
  return (
    <div className="tw-flex tw-h-full tw-items-center tw-justify-center">
      <DotsLoader data-testid="dots-loader" />
    </div>
  );
};

PageLoader.displayName = "PageLoader";

export default PageLoader;
